(function navdropwdownScript($, Drupal) {
  Drupal.behaviors.navdropwdown = {
    attach: function (context, settings) {
      $('.nav-dropwdown').each(function(){
        var $nav = $(this);
        var $cnt = $(this).find('.nav-dropwdown__cnt');
        $(this).find('.nav-dropwdown__hdl').click(function(){
          $nav.toggleClass('open');
        })
      })
    },
  };
}(jQuery, Drupal));
